const styles = ({ typography }) => ({
  title: {
    height: typography.pxToRem(42),
  },
});

export default styles;
